import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import rehypeRaw from 'rehype-raw'

const Markdown = ({ text, ...props }) => {
  const safeText = typeof text === 'string' ? text : ''

  const processedText = safeText
    .replaceAll('[markdown]', '')
    .replace(/\[([^\]]+)\](?!\()/g, '\\[$1\\]')
    .replace(/\^([\s\S]*?)\^/g, '<sup>$1</sup>')
    .replace(/~([\s\S]*?)~/g, '<sub>$1</sub>')
    .replace(/(\*\*[\s\S]+?\*\*)_(\*\*[\s\S]+?\*\*)_/g, '$1 _$2_')

  try {
    return (
      <ReactMarkdown
        components={{
          a: ({ href, children }) => {
            if (!href) return <>[{children}]</>
            return (
              <a href={href} rel='noreferrer' target='_blank'>
                {children}
              </a>
            )
          },
          p: ({ children }) => <span>{children}</span>,
          sub: ({ children }) => <sub>{children}</sub>,
          sup: ({ children }) => <sup>{children}</sup>,
        }}
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[remarkBreaks]}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {processedText}
      </ReactMarkdown>
    )
  } catch (error) {
    throw {
      message: 'Markdown failed to render - ' + error.message,
    }
  }
}

export default Markdown
